import { useCKEditor, CKEditorEventAction } from 'ckeditor4-react'
// eslint-disable-next-line no-unused-vars
export const cleanObj = <D>(obj: { [key in string]: D }) => {
  const cloneObj: typeof obj = {}
  const falseArr = [false, undefined, null] as const

  Object.keys(obj).forEach(key => {
    if (!falseArr.includes(obj[key] as any)) {
      cloneObj[key] = obj[key]
    }
  })
  return cloneObj
}

interface UseCheditorProps {
  element: HTMLElement | null
  height: number
  initData?: string
  onChange?: (data: string, editor: any) => void
  onFocus?: (data: string, editor: any) => void
  onBlur?: (data: string, editor: any) => void
  onKey?: (data: string, editor: any) => void
}

export const useCheditor = (props: UseCheditorProps) => {
  const { element, onBlur, onChange, onFocus, onKey, initData = '', height } = props
  const res = useCKEditor({
    editorUrl: '/ckeditor/ckeditor.js',
    element,
    dispatchEvent: ({ type, payload }) => {
      switch (type) {
        case CKEditorEventAction.instanceReady:
          payload.editor.setData(initData)
          break
        case CKEditorEventAction.change:
          {
            const data = payload.editor.getData().trim()
            onChange?.(data, payload.editor)
          }
          break
        case CKEditorEventAction.blur:
          {
            const data = payload.editor.getData().trim()
            onBlur?.(data, payload.editor)
          }
          break
        case CKEditorEventAction.focus:
          {
            const data = payload.editor.getData().trim()
            onFocus?.(data, payload.editor)
          }
          break
        case CKEditorEventAction.key:
          {
            const data = payload.editor.getData().trim()
            onKey?.(data, payload.editor)
          }
          break
        default:
          break
      }
    },
    config: {
      fullPage: true,
      extraPlugins: 'docprops',
      allowedContent: true,
      height,
      removeButtons: 'PasteFromWord,About',
    },
  })
  return { ...res }
}

export function getCustomUUID(): string | number {
  try {
    return crypto.randomUUID()
  } catch (error) {
    return performance.now() + Math.random()
  }
}

export const getQueryParameter = (url: string, key: string) => {
  // 创建一个URL对象（如果url已经是URL对象，则直接使用）
  const urlObj = new URL(url)

  // 使用URLSearchParams获取查询参数
  const params = new URLSearchParams(urlObj.search)

  // 尝试获取指定key的值
  const value = params.get(key)

  // 返回找到的值，如果没有找到则返回null
  return value
}

export const safeJSONParse = (str: string) => {
  if (str == null || str === '') {
    return {}
  }
  try {
    return JSON.parse(str)
  } catch (error) {
    console.error('解析JSON数据出错:', error)
    return {}
  }
}

// 添加格式化时间间隔的函数
export const formatTimeInterval = (startTime: string, endTime: string) => {
  if (!startTime || !endTime) {
    return ' -'
  }
  const interval = new Date(endTime).getTime() - new Date(startTime).getTime()
  const totalSeconds = Math.floor(interval / 1000)

  if (totalSeconds < 60) {
    return `${totalSeconds}秒`
  }

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) {
    return `${hours}小时${minutes}分${seconds}秒`
  } else if (minutes > 0) {
    return `${minutes}分${seconds}秒`
  }

  return `${seconds}秒`
}
